__turbopack_context__.v({
  "btn": "AddtoCartForm-module-scss-module__CR-ada__btn",
  "dateWrap": "AddtoCartForm-module-scss-module__CR-ada__dateWrap",
  "price": "AddtoCartForm-module-scss-module__CR-ada__price",
  "selected": "AddtoCartForm-module-scss-module__CR-ada__selected",
  "ticket": "AddtoCartForm-module-scss-module__CR-ada__ticket",
  "visuallyHidden": "AddtoCartForm-module-scss-module__CR-ada__visuallyHidden",
});
